import "./Partners.scss";
import Beep from "../../assets/logos/partners-oca/beep.png";
import BoringSecurity from "../../assets/logos/partners-oca/boring.png";
import BrainRacers from "../../assets/logos/partners-oca/brain-racers.png";
import BSDEducation from "../../assets/logos/partners-oca/bsd-education.png";
import EducUp from "../../assets/logos/partners-oca/educup.png";
import MADCourses from "../../assets/logos/partners-oca/mad-courses.png";
import Mancer from "../../assets/logos/partners-oca/mancer.jpeg";
import Mogaland from "../../assets/logos/partners-oca/moga.png";
import NearX from "../../assets/logos/partners-oca/nearx.png";
import TheTestTribe from "../../assets/logos/partners-oca/test-tribe.png";
import YieldGuideGames from "../../assets/logos/partners-oca/yield-guide-games.png";
import Zydii from "../../assets/logos/partners-oca/zydii.png";

const Partners = ({}) => {
  return (
    <div className="oca-pn-paper-root">
      <div className="container p-0">
        <span className="oca-pn-title">Our partners</span>
        <div className="oca-pn-grid">
          <img className="oca-pn-grid-item" src={Beep} alt={""} />
          <img className="oca-pn-grid-item" src={BoringSecurity} alt={""} />
          <img className="oca-pn-grid-item" src={BrainRacers} alt={""} />
          <img className="oca-pn-grid-item" src={BSDEducation} alt={""} />
          <img className="oca-pn-grid-item p-0" src={EducUp} alt={""} />
          <img className="oca-pn-grid-item" src={MADCourses} alt={""} />
          <img className="oca-pn-grid-item" src={Mancer} alt={""} />
          <img className="oca-pn-grid-item" src={Mogaland} alt={""} />
          <img className="oca-pn-grid-item" src={NearX} alt={""} />
          <img className="oca-pn-grid-item" src={TheTestTribe} alt={""} />
          <img
            className="oca-pn-grid-item"
            src={YieldGuideGames}
            alt={""}
          />
          <img className="oca-pn-grid-item" src={Zydii} alt={""} />
        </div>
      </div>
    </div>
  );
};

export default Partners;
